import { render, staticRenderFns } from "./OnRatiosEmploisTotal.vue?vue&type=template&id=35b764c2&"
import script from "./OnRatiosEmploisTotal.vue?vue&type=script&lang=js&"
export * from "./OnRatiosEmploisTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports